import { defineMessages } from 'react-intl';

export const messages: {
	uploadImageFailedDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	uploadImageFailedTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	uploadImageFailedDescription: {
		id: 'company-hub.company-hub-common.shared-components.unsplash-search.upload.error.description',
		defaultMessage: 'Refresh the page and try again',
		description: `Description of flag shown when the extensions' uploaded image failed to load`,
	},
	uploadImageFailedTitle: {
		id: 'company-hub.company-hub-common.shared-components.unsplash-search.upload.error.title',
		defaultMessage: 'Image failed to load',
		description: `Title of flag shown when the extensions' uploaded image failed to load`,
	},
});
